import React, { memo, useCallback, useState, useEffect } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import icon_tipping_detail from "assets/icon_tipping_detail.png";
import { Input, Modal, notification } from "antd";
import ItemTipping from "containers/tipping/itemTipping";
import ServiceBase from "utils/ServiceBase";
import { toast } from "react-toastify";
import RatingOnModal from "containers/rating/index";
import ModalLoading from "components/modal/Loading";
import icon_toast_success from "assets/icon_toast_success.png";
import icon_warning from "assets/icon_warning.png";
import { checkNetworkConnection } from "utils/ServiceBase";
import {
  setOpenNoInternetModal,
  pushApiErrorData,
  setApiErrorOpen,
} from "redux/action";
import { useDispatch } from "react-redux";

const ModalTipping = memo(({ className, onClose, isShow }) => {
  const { t } = useTranslation("translation");
  const [tipping, setTipping] = useState("");
  const [iShowModalRating, setShowModalRating] = useState(false);
  const homeBrand = useSelector((state) => state.rootReducer.homeBrand);
  const tipTopDown = useSelector((state) => state.rootReducer.tipTopDown);
  const [tippingList, setTippingList] = useState([]);
  const [isDisableInputTipping, setDisableInputTipping] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listRating, setListRating] = useState("");
  const [disableButtonTiping, setDisableButtonTiping] = useState(false);
  const ratingGuid = useSelector((state) => state.rootReducer.ratingGuid);
  const dispatch = useDispatch();

  const handleCheckNetworkConnect = () => {
    if (checkNetworkConnection()) return true;
    else {
      dispatch(setOpenNoInternetModal(true));
      return false;
    }
  };

  const onSubmitTipping = () => {
    let data = convertDataTipping();
    console.log(data);
    if (data) {
      if (data?.["tipping-amount"] === "") {
        notification.warning({
          message: `${t("notifyContentError")}`,
          description: " ",
        });
      } else {
        if (disableButtonTiping === false) {
          submitTipping(data);
          setDisableButtonTiping(true);
        }
      }
    } else {
      onClose();
    }
  };

  const onCloseModalTipping = () => {
    onClose();
  };

  const convertDataTipping = () => {
    let data;
    let isSelected = false;
    tippingList.forEach((item) => {
      if (item.isSelected) {
        isSelected = true;
        data = {
          "tipping-amount": item?.["amount"],
          guid: `{${homeBrand?.qrCode}}`,
        };
      }
    });
    if (!isSelected) {
      if (!/^[0-9]+$/.test(tipping)) {
        toast.error(
          <div className="font-500 text-black">
            {t("tipAmountDigitsOnly")}
          </div>,
          {
            icon: () => <img src={icon_warning} />,
            className: "toast_one_line",
          }
        );
        // toast.error("Số tiền tip chỉ gồm ký tự số");
      } else {
        data = {
          "tipping-amount": tipping,
          guid: `{${homeBrand?.qrCode}}`,
        };
      }
    }
    return data;
  };
  const handlePushApiError = (api) => {
    dispatch(pushApiErrorData([api]));
  };

  const handleShowApiErrors = () => {
    notification.close("internalServerError");
    dispatch(setApiErrorOpen(true));
  };

  const submitTipping = async (payload) => {
    if (!handleCheckNetworkConnect()) return;
    setLoading(true);
    const response = await ServiceBase.requestJson({
      method: "POST",
      url: `ggg/api/v3.0/cs/tipping-draft`,
      data: {
        "tipping-amount": payload?.["tipping-amount"],
        guid: payload?.guid,
      },
    });
    if (response?.value?.code === "200") {
      setLoading(false);
      if (ratingGuid !== homeBrand?.qrCode && isShow) {
        setShowModalRating(true);
      } else {
        onCloseModalTipping();
      }
      toast.success(
        <div className="font-500 text-black">{t("notifyContentTipping")}</div>,
        {
          icon: () => <img src={icon_toast_success} />,
          className: "toast_one_line",
        }
      );
      // notification.open({
      //   message: `${t("notifyContentTipping")}`,
      //   description: " ",
      //   icon: (
      //     <CheckCircleFilled
      //       style={{ color: "#47C751", background: "#ffffff" }}
      //     />
      //   ),
      // });
    } else {
      setLoading(false);
      if (response?.value?.code === "401") {
        return toast.error(
          response?.value?.mess ||
            response?.value?.message ||
            response?.value?.code
        );
      } else {
        if (response?.code === "ECONNABORTED") {
          const url = `ggg/api/v3.0/cs/tipping-draft`;
          handlePushApiError({ url, time: Date.now() });
          notification["error"]({
            key: "internalServerError",
            message: t("internalServerError"),
            duration: 15,
            description: (
              <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
                {t("forDev")}
              </span>
            ),
          });
        } else {
          return toast.error(response?.value?.mess || response?.value?.message);
        }
      }
    }
  };

  const onSelected = (item, index) => {
    tippingList?.map((itemTipping) => {
      if (itemTipping?.key === item?.key) {
        itemTipping.isSelected = !itemTipping.isSelected;
        if (itemTipping.isSelected) {
          setDisableInputTipping(true);
        } else {
          setDisableInputTipping(false);
        }
      } else {
        itemTipping.isSelected = false;
      }
    });
    setTippingList([...tippingList]);
  };

  const updateTipping = useCallback((tipping) => {
    setTipping(tipping);
  });

  const onShowModalRating = () => {
    if (isShow && ratingGuid !== homeBrand?.qrCode) {
      setShowModalRating(true);
    } else {
      onCloseModalTipping();
    }
  };

  useEffect(() => {
    setLoading(true);
    getListTippingSuggest();
    getListRatingSuggest();
  }, [homeBrand]);

  const getListRatingSuggest = async () => {
    if (!handleCheckNetworkConnect()) return;
    const response = await ServiceBase.requestJson({
      method: "GET",
      url: `/ggg/api/v4.0/cs/getAllowPoints?app-code=${"CO_WEB"}`,
      data: {},
      restaurantCode: homeBrand?.restaurantCode,
    });
    if (response?.value?.code === "200") {
      setLoading(false);
      if (response?.value?.data) {
        setListRating(response?.value?.data);
      } else {
        toast.error(t("noRatingList"));
      }
    } else {
      setLoading(false);
      if (response?.value?.code === "401") {
        toast.error(
          response?.value?.mess || response?.value?.message || t("error")
        );
      } else {
        if (response?.code === "ECONNABORTED") {
          const url = `/ggg/api/v4.0/cs/getAllowPoints?app-code=${"CO_WEB"}`;
          handlePushApiError({ url, time: Date.now() });
          notification["error"]({
            key: "internalServerError",
            message: t("internalServerError"),
            duration: 15,
            description: (
              <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
                {t("forDev")}
              </span>
            ),
          });
        } else {
          toast.error(response?.value?.mess || response?.value?.message);
        }
      }
    }
  };

  const getListTippingSuggest = async () => {
    if (!handleCheckNetworkConnect()) return;
    const response = await ServiceBase.requestJson({
      method: "GET",
      url: `/ggg/api/v3.0/cs/getNewSuggestAmount`,
      data: {},
      restaurantCode: homeBrand?.restaurantCode,
    });
    let isCheckFormatItem = false;
    if (response?.value?.code === "200") {
      if (response?.value?.data) {
        let listTippingSuggest = [];
        if (tipTopDown && tipTopDown.length > 0) {
          try {
            tipTopDown.forEach((item, index) => {
              if (isNumber(item)) {
                var itemTipTopDown = {
                  amount: parseInt(item),
                  isSelected: false,
                  key: index,
                };
                listTippingSuggest.push(itemTipTopDown);
              } else {
                isCheckFormatItem = true;
              }
            });
            if (isCheckFormatItem) {
              listTippingSuggest = [];
              response?.value?.data.forEach((item, index) => {
                item.isSelected = false;
                item.key = index;
                listTippingSuggest.push(item);
              });
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          response?.value?.data.forEach((item, index) => {
            item.isSelected = false;
            item.key = index;
            listTippingSuggest.push(item);
          });
        }
        setTippingList([...listTippingSuggest]);
      } else {
        toast.error(t("noTippingList"));
      }
    } else {
      if (response?.value?.code === "401") {
        toast.error(
          response?.value?.mess || response?.value?.message || t("error")
        );
      } else {
        if (response?.code === "ECONNABORTED") {
          const url = `/ggg/api/v3.0/cs/getNewSuggestAmount`;
          handlePushApiError({ url, time: Date.now() });
          notification["error"]({
            key: "internalServerError",
            message: t("internalServerError"),
            duration: 15,
            description: (
              <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
                {t("forDev")}
              </span>
            ),
          });
        } else {
          toast.error(response?.value?.mess || response?.value?.message);
        }
      }
    }
  };

  const isNumber = (n) => {
    return !isNaN(parseInt(n)) && isFinite(n);
  };

  return (
    <div className={className}>
      {loading && <ModalLoading />}
      <div className={"row footer flex justify-center button-close"}>
        <CloseOutlined
          className={"btnCloseModal"}
          onClick={isShow ? onShowModalRating : onCloseModalTipping}
          style={{
            color: "#000000",
            position: "absolute",
            left: 16,
            fontSize: "22px",
            zIndex: 2,
          }}
        />
      </div>
      <div className={"row content flex justify-center"}>
        <div className="bg-tipping w-full">
          <div className="tipping-content flex justify-center">
            <img
              src={icon_tipping_detail}
              className="img-tipping-logo"
              alt="info"
            />
          </div>
          <div className="tipping-title font-700 fs-18 flex justify-center">
            {t("tippingContent")}&nbsp;
          </div>
          <div className="font-700 fs-18 flex justify-center">
            {t("tippingContent1")}&nbsp;
          </div>
          <div className="wrapper justify-center">
            {tippingList.map((item, index) => {
              return (
                <ItemTipping
                  itemTipping={item}
                  key={"item-" + item?.["amount"] + index}
                  onSelected={() => {
                    onSelected(item, index);
                  }}
                />
              );
            })}
          </div>
          <div className="tipping-input">
            <Input
              disabled={isDisableInputTipping}
              suffix="VND"
              type="tel"
              name="phone"
              maxLength="8"
              onChange={(e) => updateTipping(e.target.value)}
              style={{
                color: "black",
                height: 44,
                borderRadius: 4,
                font: 700,
              }}
              placeholder={t("tippingPlaceHolder")}
            />
          </div>
        </div>
      </div>
      <div className={"buttonModal"}>
        <div
          className={"btnleft font-medium flex justify-center items-center"}
          onClick={isShow ? onShowModalRating : onCloseModalTipping}
        >
          {t("skip")}
        </div>
        <div
          className={"btnRight font-medium flex justify-center items-center"}
          onClick={onSubmitTipping}
        >
          {t("confirm")}
        </div>
      </div>
      <Modal
        className={"custom-modal-rating modal-product-combo"}
        destroyOnClose
        open={iShowModalRating}
        footer={null}
        centered
        closable={false}
        onCancel={onCloseModalTipping}
      >
        <RatingOnModal onClose={onCloseModalTipping} listRating={listRating} />
      </Modal>
    </div>
  );
});

export default styled(ModalTipping)`
  position: relative;
  background: #ffffff;
  .wrapper {
    margin-left: 5px;
    display: flex;
    margin-right: 5px;
    flex-wrap: wrap;
  }

  .wrapper > div {
    flex: 1 0 30%;
  }
  * {
    box-sizing: border-box;
  }

  .button-close {
    margin-top: 15px;
  }
  .ant-layout-content {
    overflow-y: auto;
  }
  .tipping-title {
    margin-top: 10px;
  }
  .img-tipping-logo {
    margin-top: 10px;
  }
  .bg-tipping {
    background: #f2f2f2;
    margin-right: 20px;
    margin-left: 20px;
    margin-top: 40px;
    margin-bottom: 70px;
  }
  .tipping-input {
    height: 44px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    display: flex;
    margin-left: 10px;
    margin-right: 10px;
    justify-content: flex;
    margin-bottom: 10px;
    line-height: 18px;
    margin-top: 10px;
    font-family: "Manrope-Medium", sans-serif;
  }
  input.success:focus {
    /*or a more specific selector*/
    outline: none;
    border: 3px solid red;
  }

  .text-input {
    height: 44px;
    padding: 10px;
    display: flex;
    justify-content: start;
  }
  .btn_primary {
    width: "50%";
  }
  .buttonModal {
    position: fixed;
    bottom: 0;
    display: flex;
    left: 0;
    right: 0;
    background: #ffffff;
    /* margin-bottom: 15px;
    margin-left: 20px;
    margin-right: 20px; */
    align-items: center;
    justify-content: center;
  }
  .textarea {
    border: none;
    overflow: auto;
    outline: none;
    background: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;

    resize: none; /*remove the resize handle on the bottom right*/
  }
  .btnleft {
    color: #1a1a1a;
    background: #e6e6e6;
    border-radius: 4px;
    width: 50%;
    margin-bottom: 10px;
    margin-top: 10px;
    margin-right: 7px;
    margin-left: 20px;
    height: 44px;
  }
  .btnRight {
    color: #ffffff;
    background: #47c751;
    border-radius: 4px;
    width: 50%;
    margin-bottom: 10px;
    margin-top: 10px;
    margin-left: 7px;
    margin-right: 20px;
    height: 44px;
  }
`;
